import { combineReducers } from 'redux';

const launchDetailInitialState = {
  loadStatus: 0,
  errMsg: null,
};

function launchStatusReducer(state = 0, action) {
  switch (action.type) {
    case 'LAUNCH': {
      return 1;
    }

    case 'LAUNCH_FINISHED': {
      return action.error ? 0 : 2;
    }

    default:
      return state;
  }
}

function launchDetailReducer(state = launchDetailInitialState, action) {
  switch (action.type) {
    case 'LAUNCH': {
      return {
        ...state,
        loadStatus: 1,
        errMsg: null,
      };
    }

    case 'LAUNCH_FINISHED': {
      const { error } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
          errMsg: error.message || '未知错误',
        };
      }

      return {
        ...state,
        loadStatus: 2,
        errMsg: null,
      };
    }

    default:
      return state;
  }
}

function timeOffsetReducer(state = 0, action) {
  switch (action.type) {
    case 'SYNC_SERVER_TIME': {
      return action.time;
    }

    default:
      return state;
  }
}

function wmpSceneReducer(state = '', action) {
  switch (action.type) {
    case 'SET_WMP_SCENE': {
      return action.value
    }
    default:
      return state
  }
}

export default combineReducers({
  launchStatus: launchStatusReducer,
  launchDetail: launchDetailReducer,
  timeOffset: timeOffsetReducer,
  wmpScene: wmpSceneReducer,
});
